export { default } from "./card.svelte";
